import api from './api';

export enum NotificationEntity {
  PATIENT = 'PATIENT',
  QUESTIONNAIRE = 'QUESTIONNAIRE',
  MEETING = 'MEETING',
}

export const NOTIFICATION_ENTITY_LABELS: Record<NotificationEntity, string> = {
  [NotificationEntity.PATIENT]: 'Patient',
  [NotificationEntity.QUESTIONNAIRE]: 'Questionnaire',
  [NotificationEntity.MEETING]: 'Meeting',
};


export interface CriteriaItem {
  field: string;
  operator: string;
  value?: string;
}

export interface PatientNotification {
  id: number;
  name: string;
  entity: NotificationEntity;
  is_active: boolean;
  include_criteria: CriteriaItem[] | null;
  exclude_criteria: CriteriaItem[] | null;
  email_template_id: number | null;
  sms_template_id: number | null;
  reminder_email_template_id: number | null;
  reminder_sms_template_id: number | null;
  send_reminders: boolean;
  reminder_count: number | null;
  days_between_reminders: number | null;
  start_from: string | null;
  schedule: string | null;
  questionnaire_type_id: number | null;
  tenant_id: number;
  created_at: string;
  updated_at: string;
}

export interface PatientNotificationCreate {
  name: string;
  entity: NotificationEntity;
  is_active?: boolean;
  include_criteria?: CriteriaItem[];
  exclude_criteria?: CriteriaItem[];
  email_template_id?: number | null;
  sms_template_id?: number | null;
  reminder_email_template_id?: number | null;
  reminder_sms_template_id?: number | null;
  send_reminders?: boolean;
  reminder_count?: number | null;
  days_between_reminders?: number | null;
  start_from?: string | null;
  schedule?: string | null;
  questionnaire_type_id?: number | null;
  tenant_id: number;
}

export interface PatientNotificationUpdate {
  name?: string;
  entity?: NotificationEntity;
  is_active?: boolean;
  include_criteria?: CriteriaItem[];
  exclude_criteria?: CriteriaItem[];
  email_template_id?: number | null;
  sms_template_id?: number | null;
  reminder_email_template_id?: number | null;
  reminder_sms_template_id?: number | null;
  send_reminders?: boolean;
  reminder_count?: number | null;
  days_between_reminders?: number | null;
  start_from?: string | null;
  schedule?: string | null;
  questionnaire_type_id?: number | null;
}

export const patientNotificationService = {
  async getAll(tenantId?: number): Promise<PatientNotification[]> {
    const params = tenantId ? `?tenant_id=${tenantId}` : '';
    const response = await api.get(`/patient-notifications/${params}`);
    return response.data;
  },

  async getById(id: number): Promise<PatientNotification> {
    const response = await api.get(`/patient-notifications/${id}`);
    return response.data;
  },

  async create(data: PatientNotificationCreate): Promise<PatientNotification> {
    const response = await api.post('/patient-notifications/', data);
    return response.data;
  },

  async update(id: number, data: PatientNotificationUpdate): Promise<PatientNotification> {
    const response = await api.put(`/patient-notifications/${id}`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/patient-notifications/${id}`);
  },

  async run(id: number): Promise<{ message: string; job_id: number }> {
    const response = await api.post(`/patient-notifications/${id}/run`);
    return response.data;
  },
};
